const Sauces = () => {
  return (
    <section className="sauces">
      <br />
      <label for="sauce">
        <strong>What type of sauce would you like?</strong>
      </label>
      <br />
      <br />
      <select name="sauce">
        <option value="ketchup">Ketchup</option>
        <option value="mustard">Mustard</option>
        <option value="mayonnaise">Mayonnaise</option>
        <option value="garlic aioli">Garlic Aioli</option>
        <option value="fancy sauce">Fancy Sauce</option>
      </select>
      <br />
      <br />
    </section>
  );
};

export default Sauces;
